import React from "react";
import Label from "components/general/Label"
import Competitor from "components/presentation/Competitor";
import { Card } from "react-bootstrap";


export const Currents = (props) => {
    const { data } = props;
    let boulders = data?.config?.extendedConfig?.filter(cfg => cfg?.code === 'BOULDER')?.sort((a, b) => a?.pos - b?.pos)?.map(i => ({ pos: i?.pos, value: i?.value }));
    boulders = Array.isArray(boulders) && boulders.length > 0 ? boulders : [{ pos: '1', value: '1' }, { pos: '2', value: '2' }, { pos: '3', value: '3' }, { pos: '4', value: '4' }];
    let currents = data?.results?.extendedInfos?.filter(ei => ei?.ei_code === 'CURRENT')?.map(ei => ({ code: ei?.ei_value, pos: ei?.ei_pos }))
    let out = boulders?.map(b => <BoulderCard key={b.pos} boulder={b} data={data} currents={currents} />)
    return <>
        <div className="currents">
            <h4><Label data='LabelCurrentCompetitors' /></h4>
            <div className="d-flex justify-content-between">{out}</div>
        </div>
    </>

}

const BoulderCard = ({ boulder, data, currents }) => {

    let compCode = currents?.find(c => c?.pos === boulder?.pos)?.code;
    let res = data?.results?.items?.find(item => item?.participant?.code === compCode);

    return (<>
        <Card>
            <Card.Body>
                <Card.Title className="text-center"><Label data='HeaderBoulder' /> {boulder?.pos}</Card.Title>
                <Card.Subtitle><Competitor {...res} hidePicture={true} alwaysNoc={true} /></Card.Subtitle>
                <Card.Text>
                    <Zones data={res} boulder={boulder} />
                </Card.Text>
            </Card.Body>
        </Card>
    </>)
}


const Zones = ({ data, boulder }) => {
    let er = data?.extendedResults?.find(er => er?.er_pos === boulder?.pos)
    let value = er?.er_value2
    const out = (<table>
        <tbody>
            <tr>
                <td></td>
                <td className="text-end"><Label data='LabelTop' /></td>
                <td className={getGreen(value, 3)}></td>
                <td>{sowResult(data, value, 3)}</td>
            </tr>
            <tr className="d-none">
                <td></td>
                <td className="text-end"><Label data='LabelHighZone' /></td>
                <td className={getGreen(value, 2)}></td>
                <td>{sowResult(data, value, 2)}</td>
            </tr>
            <tr>
                <td></td>
                <td className="text-end"><Label data='LabelLowZone' /></td>
                <td className={getGreen(value, 1)}></td>
                <td>{sowResult(data, value, 1)}</td>
            </tr>
            <tr>
                <td></td>
                <td className="text-end"><Label data='HeaderAttempts' /></td>
                <td>{er?.er_arrive}</td>
                <td></td>
            </tr>
        </tbody>
    </table>)

    return out;

}

const getGreen = (value, level) => {
    let levelN = value === 'TOP' ? 3 : value === 'HIGH' ? 2 : value == 'LOW' ? 1 : 0;
    return levelN >= level ? 'level bg-success' : 'level'
}

const sowResult = (data, value, level) => {
    let levelN = value === 'TOP' ? 3 : value === 'HIGH' ? 2 : value == 'LOW' ? 1 : 0;
    return levelN === level ? data?.resultData : '';
}
